export class CostReviewAgreementScopeSa {
    isDesigoCcChecked: boolean = false;
    desigoCc: string = '';
    isDesigoCcUpgradesIncludedChecked: boolean = false;
    expirationDate: string = '';
    isWinPmChecked: boolean = false;
    winPm: string = '';
    isWinPmUpgradesIncludedChecked: boolean = false;
    isApogeeInsightChecked: boolean = false;
    apogeeInsight: string = '';
    isArculesChecked: boolean = false;
    arcules: string = '';
    isSiPassChecked: boolean = false;
    siPass: string = '';
    isVmsSiveillanceChecked: boolean = false;
    vmsSiveillance: string = '';
    isOperatingSystemChecked: boolean = false;
    operatingSystem: string = '';
    isOperatingSystemUpgradesIncludedChecked: boolean = false;
    isThirdPartyOneChecked: boolean = false;
    thirdPartyOne: string = '';
    isThirdPartyOneUpgradesIncludedChecked: boolean = false;
    isThirdPartyTwoChecked: boolean = false;
    thirdPartyTwo: string = '';
    isThirdPartyTwoUpgradesIncludedChecked: boolean = false;
    isThirdPartyThreeChecked: boolean = false;
    thirdPartyThree: string = '';
    isThirdPartyThreeUpgradesIncludedChecked: boolean = false;
    firmwareUpgradesIncluded: string = '';
    remoteConnectionRequired: string = '';
    connectionTypes: any[] = [];
    installationIncludedCrspSetup: string = '';
    remoteConnectionForCsc: string = '';
    cscConnectionProvidedBy: number = 0;
    customerAgreedToRemoteAccess: number = 0;
    siteHasReno: number = 0;
    datamateAdvancedInstalled: number = 0;
    adminRightsToSystem: number = 0;
    unusualFrequencyOfVisit: number = 0;
    customerSpecificTasking: number = 0;
    coilCleaningIncluded: number[] = [];
    afterHoursOrSeasonal: number = 0;
    customerReportingRequired: any[] = [];
    fireMonitoringIncluded: string = '';
    alarmManagementIsConfigured: string = '';
    cellularIpWireless: number = 0;
    panelAreaOfRescue: number = 0;
    securityMonitoringIncluded: string = '';
    alarmManagementIsConfiguredSecurity: string = '';
    cellularIpWirelessSecurity: number = 0;
    panelAreaOfRescueSecurity: number = 0;
    preApogeePointNaming: number = 0;
    navigatorScopeOfServices: number = 0;
    automationHealthReportIncluded: string = '';
    bmsBackupSiteExplorer: number = 0;
    automationSubcontractorWork: string = '';
    detailedQuoteProvidedAutomation: number = 0;
    mechanicalSubcontractorWork: string = '';
    detailedQuoteProvidedMechanical: number = 0;
    electricalSubcontractorWork: string = '';
    detailedQuoteProvidedElectrical: number = 0;
    energySubcontractorWork: string = '';
    detailedQuoteProvidedEnergy: number = 0;
    fireSubcontractorWork: string = '';
    detailedQuoteProvidedFire: number = 0;
    sprinklerSubcontractorWork: string = '';
    detailedQuoteProvidedSprinkler: number = 0;
    securitySubcontractorWork: string = '';
    detailedQuoteProvidedSecurity: number = 0;
    bondIncludedInSubcontractor: number = 0;
    isSixCharPointChecked: boolean = false;
}
